import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[appTooltip]',
  standalone: false,
})
export class TooltipDirective implements OnInit, OnDestroy {
  @Input('appTooltip') tooltipText = '';
  tooltip: HTMLElement | null = null;

  private mouseEnterSubject = new Subject<void>();
  private mouseEnterSubscription: Subscription = new Subscription();

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.mouseEnterSubscription = this.mouseEnterSubject
      .pipe(debounceTime(200))
      .subscribe(() => {
        this.showTooltip();
      });
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.mouseEnterSubject.next();
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip) {
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }
  }

  @HostListener('mousemove', ['$event']) onMouseMove(event: MouseEvent) {
    if (this.tooltip) {
      this.setPosition(event);
    }
  }

  ngOnDestroy(): void {
    this.onMouseLeave();
    this.mouseEnterSubscription.unsubscribe();
  }

  private showTooltip(): void {
    if (!this.tooltip && this.tooltipText) {
      this.tooltip = this.renderer.createElement('span');
      const text = this.renderer.createText(this.tooltipText);
      this.renderer.appendChild(this.tooltip, text);
      this.renderer.appendChild(document.body, this.tooltip);
      this.renderer.setStyle(this.tooltip, 'position', 'fixed');
      this.renderer.setStyle(this.tooltip, 'background', '#333');
      this.renderer.setStyle(this.tooltip, 'color', '#fff');
      this.renderer.setStyle(this.tooltip, 'padding', '4px 8px');
      this.renderer.setStyle(this.tooltip, 'borderRadius', '4px');
      this.renderer.setStyle(this.tooltip, 'fontSize', '12px');
      this.renderer.setStyle(this.tooltip, 'zIndex', '1000');
      this.renderer.setStyle(this.tooltip, 'pointerEvents', 'none');
      this.setPosition();
    }
  }

  private setPosition(event?: MouseEvent) {
    const offset = 10;
    let x = 0,
      y = 0;
    if (event) {
      x = event.clientX + offset;
      y = event.clientY + offset;
    } else {
      const rect = this.el.nativeElement.getBoundingClientRect();
      x = rect.right + offset;
      y = rect.top + offset;
    }
    this.renderer.setStyle(this.tooltip, 'left', `${x}px`);
    this.renderer.setStyle(this.tooltip, 'top', `${y}px`);
  }
}
